export var FinishOperationContent;
(function (FinishOperationContent) {
    FinishOperationContent["StopPumping"] = "Stop pumping";
    FinishOperationContent["HoseDiscon"] = "Hose discon.";
    FinishOperationContent["BargeOff"] = "Barge off";
})(FinishOperationContent || (FinishOperationContent = {}));
//# sourceMappingURL=FinishOperationContent.js.map